import React from 'react';
import {
  Selectors,
  useWidgetState,
} from '@eCommerce/frontend-legacy-shared-library-native';
import WinLossStatementsModule from 'components/WinLossStatementsModule';

export interface ConnectedWinLossStatementsModuleProps {
  maintenance?: {isMaintenance: boolean; maintenanceEnd: number | undefined};
}

const ConnectedWinLossStatementsModule = ({maintenance}) => {
  const oToken = useWidgetState(Selectors.webviewPatronTokenSelector) as string;
  return <WinLossStatementsModule maintenance={maintenance} oToken={oToken} />;
};

export default ConnectedWinLossStatementsModule;
